'use client';

import React, { useState } from 'react';
import {
  Box,
  Button,
  Modal,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  FormControl,
  Stack
} from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: 2
};

const ModalDialog = ({ open, handleClose, onSubmit }) => {
  const [exhibitorName, setExhibitorName] = useState('');
  const [price, setPrice] = useState('');
  const [conversionType, setConversionType] = useState('Minimal');

  const handleSubmit = () => {
    const formData = {
      exhibitorName,
      price,
      conversionType
    };
    onSubmit(formData);
    handleClose(); // close modal
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Exhibitor Details
        </Typography>

        <Stack spacing={2}>
          <TextField
            label="Exhibitor Name"
            fullWidth
            value={exhibitorName}
            onChange={(e) => setExhibitorName(e.target.value)}
          />

          <TextField
            label="Price"
            type="number"
            fullWidth
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />

          <FormControl>
            <FormLabel>Convert Type</FormLabel>
            <RadioGroup
              row
              value={conversionType}
              onChange={(e) => setConversionType(e.target.value)}
            >
              <FormControlLabel value="Minimal" control={<Radio />} label="Minimal" />
              <FormControlLabel value="Full" control={<Radio />} label="Full" />
            </RadioGroup>
          </FormControl>

          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Submit
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ModalDialog;
